var map = {
	"./bg/index.json": [
		"I6W1"
	],
	"./de/index.json": [
		"qAOJ"
	],
	"./en/index.json": [
		"kacW"
	],
	"./fr/index.json": [
		"QqkC"
	],
	"./it/index.json": [
		"2Uab"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "HH3b";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locale lazy ^\.\/.*\/index\.json$
// module id = HH3b
// module chunks = 32